export default __webpack_public_path__ + "static/media/loading.11322c13.gif";